import React from "react";
import { Link } from "react-router-dom";
import { FavoritesIcon } from "../components";
import { contentTypeImages } from "./CultureCardTypes";

const CultureCustomsCard = ({
  id,
  slug,
  title,
  catList,
  favorite,
  searchQuery,
  onToggleFavorite,
  imageUrl,
}) => {
  if (searchQuery && !title.toLowerCase().includes(searchQuery.toLowerCase())) {
    return null; // Hide card if it doesn't match search
  }
  return (
    <div className="relative">
      {/* Card content */}
      <Link to={`/culture-and-customs/` + slug}>
        <img
          src={imageUrl}
          className="object-cover rounded-xl w-full h-[176px]"
          alt="Culture Customs"
        />
        <div className="absolute inset-0 rounded-xl bg-gradient-black hover:bg-gradient-black-hover"></div> 
        <p className="absolute bottom-[52px] left-4 right-4 text-base font-semibold text-white-50">
          {title}
        </p>
        <div className="absolute flex justify-end bottom-4 left-4 right-4">
          {Array.isArray(catList) && catList.filter(Boolean).length > 0 && (
            <div className="flex gap-2">
              {catList.filter(Boolean).map((category, index) => (
                <p
                  key={index}
                  className="px-2 py-1 text-xs rounded-3xl bg-gold-200 bg-opacity-30 text-gold-100"
                >
                  {category}
                </p>
              ))}
            </div>
          )}

          <button
            type="button"
            onClick={(e) => {
              e.preventDefault(); // Prevent default behavior to stop reload
              e.stopPropagation(); // Prevent event bubbling
              onToggleFavorite(id, e);
            }}
            className="focus:outline-none"
          >
            <FavoritesIcon
              filled={Boolean(favorite)}
              className={`h-6 w-6 transition-colors duration-200 ${
                favorite ? "text-red-100" : "text-gray-500 hover:text-red-100"
              }`}
            />
          </button>
        </div>
      </Link>
    </div>
  );
};

export default CultureCustomsCard;
